// extracted by mini-css-extract-plugin
module.exports = {"media_list":"styles_media_list__CLFJI"};